import Info from "component/details/Info";
import BannerImage from "component/details/BannerImage";
import GameButtons from "component/details/GameButtons";
import RoundDetails from "component/details/RoundDetails";

export { Info };
export { BannerImage };
export { GameButtons };
export { RoundDetails };

export default Object.assign({
  Info,
  BannerImage,
  GameButtons,
  RoundDetails,
});
